import organisationService from "services/maintenance/organisationService";
import AgencyInformation from "features/maintenance/components/DedicatedForms/AgencyInformation";
import { CorporateFareOutlined } from "@mui/icons-material";
import MAINTENANCE_STORE_SELECTORS from "features/maintenance/dataStore/selectors";

const organisationResource = {
    title: "Agency",
    singular: "Agencies",
    displayField: "name",
    freeForm: true,
    editableForm: AgencyInformation,
    pageIcon: CorporateFareOutlined,
    setter: MAINTENANCE_STORE_SELECTORS.ORGANISATION,

    service: organisationService,

    columns: [
        {
            field: "name",
            header: "Company Name"
        },
        {
            field: "address",
            header: "Address"
        },
        {
            field: "createdByName",
            header: "Created By",
            width: "10%"
        },
        {
            field: "updatedByName",
            header: "Updated By",
            width: "10%"
        }
    ],

    fields: [
        {
            name: "name",
            label: "Agency Name",
            type: "text",
            required: true
        },
        {
            name: "address",
            label: "Address",
            type: "text",
            required: true
        },
        {
            name: "emailAddress",
            label: "Email Address",
            type: "text"
        },
        {
            name: "webSite",
            label: "Web Site",
            type: "text"
        },
        {
            name: "tinNumber",
            label: "TIN",
            type: "text"
        },
        {
            name: "sssNumber",
            label: "SSS",
            type: "text"
        },
        {
            name: "gsisNumber",
            label: "GSIS",
            type: "text"
        },
        {
            name: "philHealthNumber",
            label: "PhilHealth",
            type: "text"
        }
    ],
    searchFields: ["name"]
};

export default organisationResource;
